import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Title from '../../commonComponents/Title';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import translate from '../../commonComponents/translate';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import TopicBanner from '../../commonComponents/pageLayout/header/TopicBanner';
import Sessions from './Sessions';
import CategoryProp from '../academy/propTypes/categoryProp';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import CurrencyProp from '../profile/propTypes/currencyProp';
import HardSkillProp from '../challenges/propTypes/hardSkillProp';
import PriceRangeProp from '../academy/propTypes/PriceRangeProp';
import MetaContext from '../../contextProviders/MetaContext';

function SessionWrapper(props) {
  const {
    t,
    categories,
    languages,
    currencies,
    skills,
    applyFilters,
    priceRange,
  } = props;
  const { userPortalMenus } = useContext(MetaContext);
  const title =
    userPortalMenus.find(u => u.type === 'academy')?.name ||
    t('academy_head_title');
  const hasWhiteBar = true;
  const filter = 'sessions';
  return (
    <Title title={t('academy.whiteBar.sessions')}>
      <ContentContainer>
        <SubHeader title={title} hasWhiteBar={hasWhiteBar} filter={filter} />
        <TopicBanner />
        <div className="m-content">
          <div className="row full-page-container-with-subheader">
            <div className="col-lg-12">
              <Sessions
                categories={categories}
                languages={languages}
                currencies={currencies}
                skills={skills}
                applyFilters={applyFilters}
                priceRange={priceRange}
              />
            </div>
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

SessionWrapper.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape(CategoryProp.propType))
    .isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
  skills: PropTypes.arrayOf(PropTypes.shape(HardSkillProp.propType)).isRequired,
  applyFilters: PropTypes.bool,
  priceRange: PropTypes.shape(PriceRangeProp.propType).isRequired,
};

SessionWrapper.defaultProps = {
  applyFilters: false,
};

export default translate(SessionWrapper);
